import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
  productlist: [],
  selectedproduct: null,
  orderpaid: null,
  orderform: null,
  slidepage: 0,


  // new stuff .....

  skuquantitylist: { selectedsku: [] },  // the object cached in storage
  cartlength: 0,
  skulist: [], //list of raw skus (tracker, pro and hubs)
  skinskulist: [], //list of raw skin skus
  skulist4display: [], // list of skus for home page only
  imagelist: [], // list of images for a selected shopping page
  imagelistskin: [],

  selectedindex: 0,
  hoverindex: 0,
  extrasensorclass: [false, false, false, false, false, false, false],
  discount_percent: 0,
  discount_amount: 0,
  couponid: null,
  skuname: "",
  skuprice: "",
  stock: 0,
  hub_sku: null,
  tracker_pro_sku: null,

  price_1_1: 0,
  price_2_1: 0,
  price_tracker: 0,
  price_tracker_pro: 0,
  price_hub: 0,
  price_skin: 0,

  inventory: {
    adaptor_us:{
      productname: "Adaptor US/CA Type A",
      id: "sku_adaptor_us",
      base_price: 499,
      price: 499,
      attributes: {
        Style: "US_Type_A",
      },

      images: ["/img/products/adaptor_us.png"]
    },
    adaptor_au:{
      productname: "Adaptor AU Type I",
      id: "sku_adaptor_au",
      base_price: 499,
      price: 499,
      attributes: {
        Style: "AU_Type_I",
      },

      images: ["/img/products/adaptor_au.png"]
    },
    standardhub: {
      productname: "Standard Hub",
      id: "sku_Hef4b2SkEJj6hx",
      base_price: 1499,
      price: 1499,
      attributes: {
        Style: "White",
      },

      images: ["/img/products/hub_1.jpg",
        "/img/products/hub_2.jpg",
        "/img/products/hub_3.jpg",
        "/img/products/hub_4.jpg"]
    },
    travelhub: {
      productname: "Truthbrush Hub",
      id: "sku_hub_travel",
      base_price: 1499,
      price: 1499,
      attributes: {
        Style: "White",
      },
      images: ["/img/products/travel_hub_1.jpg",
        "/img/products/travel_hub_2.jpg",
        "/img/products/travel_hub_3.jpg",
        "/img/products/travel_hub_4.jpg"]
    },
    skin: {
      penguin: {
        productname: "Skin",
        id: "sku_JYEBnd8hZ4nZMw",
        base_price: 499,
        price: 499,
        color: "#A0D2FE",
        attributes: {
          Style: "Penguin",
        },
        images: ["/img/products/skins/penguin_1.jpg",
          "/img/products/skins/penguin_2.png",
          "/img/products/skins/penguin_3.png",
          "/img/products/skins/penguin_4.jpg"]
      },
      flag: {
        productname: "Skin",
        id: "sku_JYED5h1Z9olKgH",
        base_price: 499,
        price: 499,
        color: "#335593",
        attributes: {
          Style: "Flag",
        },
        images: ["/img/products/skins/flag_1.jpg",
          "/img/products/skins/flag_2.png",
          "/img/products/skins/flag_3.png",
          "/img/products/skins/flag_4.jpg"]
      },
      baseball: {
        productname: "Skin",
        id: "sku_JYE9o5HFqMU03D",
        base_price: 499,
        price: 499,
        color: "#E8BC7C",
        attributes: {
          Style: "Baseball",
        },
        images: ["/img/products/skins/baseball_1.jpg",
          "/img/products/skins/baseball_2.png",
          "/img/products/skins/baseball_3.png",
          "/img/products/skins/baseball_4.jpg"]
      },
      astronaut: {
        productname: "Skin",
        id: "sku_JYE5sPXACENxiT",
        base_price: 499,
        price: 499,
        color: "#2F95EB",
        attributes: {
          Style: "Astronaut",
        },
        images: ["/img/products/skins/astronaut_1.jpg",
          "/img/products/skins/astronaut_2.png",
          "/img/products/skins/astronaut_3.png",
          "/img/products/skins/astronaut_4.jpg"]
      },
      football: {
        productname: "Skin",
        id: "sku_JYEARXK62GA8Gq",
        base_price: 499,
        price: 499,
        color: "#4DB548",
        attributes: {
          Style: "Football",
        },
        images: ["/img/products/skins/football_1.jpg",
          "/img/products/skins/football_2.png",
          "/img/products/skins/football_3.png",
          "/img/products/skins/football_4.jpg"]
      },
      heart: {
        productname: "Skin",
        id: "sku_JYE50yNpZW5q1K",
        base_price: 499,
        price: 499,
        color: "#FF8787",
        attributes: {
          Style: "Heart",
        },
        images: ["/img/products/skins/heart_1.jpg",
          "/img/products/skins/heart_2.png",
          "/img/products/skins/heart_3.png",
          "/img/products/skins/heart_4.jpg"]
      },
      orange: {
        productname: "Skin",
        id: "sku_JYE5p55Eo75pQ3",
        base_price: 499,
        price: 499,
        color: "#FFC56E",
        attributes: {
          Style: "Orange",
        },
        images: ["/img/products/skins/orange_1.jpg",
          "/img/products/skins/orange_2.png",
          "/img/products/skins/orange_3.png",
          "/img/products/skins/orange_4.jpg"]
      },
      panda: {
        productname: "Skin",
        id: "sku_JYEBZpar5AF3Kj",
        base_price: 499,
        price: 499,
        color: "#B5B5BA",
        attributes: {
          Style: "Panda",
        },
        images: ["/img/products/skins/panda_1.jpg",
          "/img/products/skins/panda_2.png",
          "/img/products/skins/panda_3.png",
          "/img/products/skins/panda_4.jpg"]
      },
      flamingo: {
        productname: "Skin",
        id: "sku_JYE5E6DTbFuxPi",
        base_price: 499,
        price: 499,
        color: "#F27CA5",
        attributes: {
          Style: "Flamingo",
        },
        images: ["/img/products/skins/flamingo_1.jpg",
          "/img/products/skins/flamingo_2.png",
          "/img/products/skins/flamingo_3.png",
          "/img/products/skins/flamingo_4.jpg"]
      },
      unicorn: {
        productname: "Skin",
        id: "sku_JYE5r9kfzyf1fa",
        base_price: 499,
        price: 499,
        color: "#B69EFC",
        attributes: {
          Style: "Unicorn",
        },
        images: ["/img/products/skins/unicorn_1.jpg",
          "/img/products/skins/unicorn_2.png",
          "/img/products/skins/unicorn_3.png",
          "/img/products/skins/unicorn_4.jpg"]
      },
      foxcream: {
        productname: "Skin",
        id: "sku_JYEBTyHmWOAZ6W",
        base_price: 499,
        price: 499,
        color: "#87E8F5",
        attributes: {
          Style: "Foxcream",
        },
        images: ["/img/products/skins/foxcream_1.jpg",
          "/img/products/skins/foxcream_2.png",
          "/img/products/skins/foxcream_3.png",
          "/img/products/skins/foxcream_4.jpg"]
      },
      surfing: {
        productname: "Skin",
        id: "sku_JYEA2kfJErTO2R",
        base_price: 499,
        price: 499,
        color: "#FDD26E",
        attributes: {
          Style: "Surfboard",
        },
        images: ["/img/products/skins/surfing_1.jpg",
          "/img/products/skins/surfing_2.png",
          "/img/products/skins/surfing_3.png",
          "/img/products/skins/surfing_4.jpg"]
      },
      peacock: {
        productname: "Skin",
        id: "sku_JYE5t1jd59WldT",
        base_price: 499,
        price: 499,
        color: "#A9E34B",
        attributes: {
          Style: "Peacock",
        },
        images: ["/img/products/skins/peacock_1.jpg",
          "/img/products/skins/peacock_2.png",
          "/img/products/skins/peacock_3.png",
          "/img/products/skins/peacock_4.jpg"]
      },
      monstertruck: {
        productname: "Skin",
        id: "sku_JYE9ip2snMmHbt",
        base_price: 499,
        price: 499,
        color: "#FDDA25",
        attributes: {
          Style: "Monster Truck",
        },
        images: ["/img/products/skins/monstertruck_1.jpg",
          "/img/products/skins/monstertruck_2.png",
          "/img/products/skins/monstertruck_3.png",
          "/img/products/skins/monstertruck_4.jpg"]
      },
      dinosaur: {
        productname: "Skin",
        id: "sku_JYE6v4rFRfXIUJ",
        base_price: 499,
        price: 499,
        color: "#343A40",
        attributes: {
          Style: "Dinosaur",
        },
        images: ["/img/products/skins/dinosaur_1.jpg",
          "/img/products/skins/dinosaur_2.png",
          "/img/products/skins/dinosaur_3.png",
          "/img/products/skins/dinosaur_4.jpg"]
      },
      orca: {
        productname: "Skin",
        id: "sku_LccnNcrpTkgq0p",
        base_price: 499,
        price: 499,
        color: "#12B8ED",
        attributes: {
          Style: "Orca",
        },
        images: ["/img/products/skins/orca_1.jpg",
          "/img/products/skins/orca_2.png",
          "/img/products/skins/orca_3.jpg"]
      },

      monkey_king: {
        productname: "Skin",
        id: "sku_LccvxbWqTmHeIQ",
        base_price: 499,
        price: 499,
        color: "#71D3E8",
        attributes: {
          Style: "Monkey King",
        },
        images: ["/img/products/skins/monkey_king_1.jpg",
          "/img/products/skins/monkey_king_2.png",
          "/img/products/skins/monkey_king_3.jpg"]
      },
      bunny: {
        productname: "Skin",
        id: "sku_LccxHGcHKWwmks",
        base_price: 499,
        price: 499,
        color: "#B1DC6C",
        attributes: {
          Style: "Little Bunny",
        },
        images: ["/img/products/skins/bunny_1.jpg",
          "/img/products/skins/bunny_2.png",
          "/img/products/skins/bunny_3.jpg"]
      },

      owl: {
        productname: "Skin",
        id: "sku_LcczMEfXcB5jIh",
        base_price: 499,
        price: 499,
        color: "#B17B5F",
        attributes: {
          Style: "Snowy Owl",
        },
        images: ["/img/products/skins/owl_1.jpg",
          "/img/products/skins/owl_2.png",
          "/img/products/skins/owl_3.jpg"]
      },

      daisy: {
        productname: "Skin",
        id: "sku_Lce8kRMdR2GYca",
        base_price: 499,
        price: 499,
        color: "#B1DC6C",
        attributes: {
          Style: "Daisy",
        },
        images: ["/img/products/skins/daisy_1.jpg",
          "/img/products/skins/daisy_2.png",
          "/img/products/skins/daisy_3.jpg"]
      },

      griffin: {
        productname: "Skin",
        id: "sku_LcdNWHPxj9S9FH",
        base_price: 499,
        price: 499,
        color: "#282626",
        attributes: {
          Style: "Griffin",
        },
        images: ["/img/products/skins/griffin_1.jpg",
          "/img/products/skins/griffin_2.png",
          "/img/products/skins/griffin_3.jpg"]
      },

      axolotl: {
        productname: "Skin",
        id: "sku_LcdPrKU4w4Nkpi",
        base_price: 499,
        price: 499,
        color: "#E25D8D",
        attributes: {
          Style: "Axolotl",
        },
        images: ["/img/products/skins/axolotl_1.jpg",
          "/img/products/skins/axolotl_2.png",
          "/img/products/skins/axolotl_3.jpg"]
      },


      mermaid: {
        productname: "Skin",
        id: "sku_LcdSPe0COHjqxm",
        base_price: 499,
        price: 499,
        color: "#999DE5",
        attributes: {
          Style: "Mermaid",
        },
        images: ["/img/products/skins/mermaid_1.jpg",
          "/img/products/skins/mermaid_2.png",
          "/img/products/skins/mermaid_3.jpg"]
      },




      // end of skins
    },
    pro: {
      productname: "Tracker Pro",
      id: "sku_JNKG4ywfgJAjUj",
      base_price: 2999,
      price: 2999,
      attributes: {
        Style: "White",
      },
      images: ["/img/products/pro_1_1.jpg",
        "/img/products/pro_1_2.jpg",
        "/img/products/pro_1_3.jpg",
        "/img/products/pro_1_1_travelhub.jpg",
        "/img/products/pro_1_2_travelhub.jpg",
        "/img/products/pro_2.jpg",
        "/img/products/pro_3.jpg",
        "/img/products/pro_4.jpg",
        "/img/products/pro_5.jpg",
        "/img/products/pro_6.jpg"]
    },
    t1a: {
      blue: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_LfScbLkJ8vO3Xo",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Blue",
        },
        images: ["/img/products/t1-blue-0.png",
        "/img/products/t1-blue-1.png",
          "/img/products/t1-blue-2a.png",
          "/img/products/t1-blue-2b.png",
          "/img/products/t1-blue-3.png",
          "/img/products/t1-blue-4.png"
          
        ]
      },
      yellow: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_LfSczdOCKO22uf",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Yellow",
        },
        images: ["/img/products/t1-orange-0.png",
        "/img/products/t1-orange-1.png",
          "/img/products/t1-orange-2a.png",
          "/img/products/t1-orange-2b.png",
          "/img/products/t1-orange-3.png",
          "/img/products/t1-orange-4.png",
          
        ]
      },
      peacock: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefBTPV2U10IuH",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Peacock",
        },
        images: ["/img/products/peacock_1.png",
          "/img/products/peacock_2.jpg",
          "/img/products/peacock_3.png",
          "/img/products/peacock_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      heart: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefHUHXErcCh9z",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Heart",
        },
        images: ["/img/products/heart_1.png",
          "/img/products/heart_2.jpg",
          "/img/products/heart_3.png",
          "/img/products/heart_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      orange: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefIHBvkG7u7EY",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Orange",
        },
        images: ["/img/products/orange_1.png",
          "/img/products/orange_2.jpg",
          "/img/products/orange_3.png",
          "/img/products/orange_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      unicorn: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefKvVmK1thUGw",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Unicorn",
        },
        images: ["/img/products/unicorn_1.png",
          "/img/products/unicorn_2.jpg",
          "/img/products/unicorn_3.png",
          "/img/products/unicorn_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      flamingo: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefGxRyOip1jA8",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Flamingo",
        },
        images: ["/img/products/flamingo_1.png",
          "/img/products/flamingo_2.jpg",
          "/img/products/flamingo_3.png",
          "/img/products/flamingo_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      dinosaur: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefBpFaIhUd9ka",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Dinosaur",
        },
        images: ["/img/products/dinosaur_1.png",
          "/img/products/dinosaur_2.jpg",
          "/img/products/dinosaur_3.png",
          "/img/products/dinosaur_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      astronaut: {
        productname: "Classic Tracker w 6 Month Battery",
        id: "sku_HefLImsSAg1t7E",
        base_price: 1999,
        price: 1999,
        attributes: {
          Style: "Astronaut",
        },
        images: ["/img/products/astronaut_1.png",
          "/img/products/astronaut_2.jpg",
          "/img/products/astronaut_3.png",
          "/img/products/astronaut_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
    },
    t1b: {
      blue: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_LfSeHAXj1EnONP",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Blue",
        },
        images: ["/img/products/t1-blue-0.png",
          "/img/products/t1-blue-1.png",
          "/img/products/t1-blue-2a.png",
          "/img/products/t1-blue-2b.png",
          "/img/products/t1-blue-3.png",
          "/img/products/t1-blue-4.png",
          
        ]
      },
      yellow: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_LfSeQNHmJfpduJ",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Yellow",
        },
        images: ["/img/products/t1-orange-0.png",
          "/img/products/t1-orange-1.png",
          "/img/products/t1-orange-2a.png",
          "/img/products/t1-orange-2b.png",
          "/img/products/t1-orange-3.png",
          "/img/products/t1-orange-4.png",
        ]
      },

      peacock: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqKmjRmblOuh9",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Peacock",
        },
        images: ["/img/products/peacock_1.png",
          "/img/products/peacock_2.jpg",
          "/img/products/peacock_3.png",
          "/img/products/peacock_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      heart: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqKH6hBUZgnG2",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Heart",
        },
        images: ["/img/products/heart_1.png",
          "/img/products/heart_2.jpg",
          "/img/products/heart_3.png",
          "/img/products/heart_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      orange: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqJVMPQfSmmQr",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Orange",
        },
        images: ["/img/products/orange_1.png",
          "/img/products/orange_2.jpg",
          "/img/products/orange_3.png",
          "/img/products/orange_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      unicorn: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqKSny9OpTA3s",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Unicorn",
        },
        images: ["/img/products/unicorn_1.png",
          "/img/products/unicorn_2.jpg",
          "/img/products/unicorn_3.png",
          "/img/products/unicorn_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      flamingo: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqKLUXghOXhsL",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Flamingo",
        },
        images: ["/img/products/flamingo_1.png",
          "/img/products/flamingo_2.jpg",
          "/img/products/flamingo_3.png",
          "/img/products/flamingo_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      dinosaur: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqK7Q9G34Pma8",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Dinosaur",
        },
        images: ["/img/products/dinosaur_1.png",
          "/img/products/dinosaur_2.jpg",
          "/img/products/dinosaur_3.png",
          "/img/products/dinosaur_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
        ]
      },
      astronaut: {
        productname: "Classic Tracker w 1 Year Battery",
        id: "sku_JcqKEwb646eZQz",
        base_price: 2499,
        price: 2499,
        attributes: {
          Style: "Astronaut",
        },
        images: ["/img/products/astronaut_1.png",
          "/img/products/astronaut_2.jpg",
          "/img/products/astronaut_3.png",
          "/img/products/astronaut_travelhub.jpg",
          "/img/products/tracker_desc_1.jpg",
          "/img/products/tracker_desc_2.jpg",
          "/img/products/tracker_desc_3.jpg",
          
        ]
      },
    }
  },

  statesaustralia: [
    "New South Wales",
    "Queensland",
    "South Australia",
    "Tasmania",
    "Victoria",
    "Western Australia",
  ],
  statescanada: [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Northwest Territories",
    "Nova Scotia",
    "Nunavut",
    "Ontario",
    "Prince Edward Island",
    "Quebec",
    "Saskatchewan",
    "Yukon",
  ],
  statesusa: [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "Armed Forces Americas",
    "Armed Forces Pacific",
    "Armed Forces Others",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ],
  countries: [
    { value: "US", text: "United States" },
    { value: "AU", text: "Australia" },
    { value: "CA", text: "Canada" },
    { value: "AF", text: "Afghanistan" },
    { value: "AX", text: "Aland Islands" },
    { value: "AL", text: "Albania" },
    { value: "DZ", text: "Algeria" },
    { value: "AS", text: "American Samoa" },
    { value: "AD", text: "Andorra" },
    { value: "AO", text: "Angola" },
    { value: "AI", text: "Anguilla" },
    { value: "AQ", text: "Antarctica" },
    { value: "AG", text: "Antigua and Barbuda" },
    { value: "AR", text: "Argentina" },
    { value: "AM", text: "Armenia" },
    { value: "AW", text: "Aruba" },
    { value: "AT", text: "Austria" },
    { value: "AZ", text: "Azerbaijan" },
    { value: "BS", text: "Bahamas" },
    { value: "BH", text: "Bahrain" },
    { value: "BD", text: "Bangladesh" },
    { value: "BB", text: "Barbados" },
    { value: "BY", text: "Belarus" },
    { value: "BE", text: "Belgium" },
    { value: "BZ", text: "Belize" },
    { value: "BJ", text: "Benin" },
    { value: "BM", text: "Bermuda" },
    { value: "BT", text: "Bhutan" },
    { value: "BO", text: "Bolivia (Plurinational State of)" },
    { value: "BQ", text: "Bonaire" },
    { value: "BA", text: "Bosnia and Herzegovina" },
    { value: "BW", text: "Botswana" },
    { value: "BV", text: "Bouvet Island" },
    { value: "BR", text: "Brazil" },
    { value: "IO", text: "British Indian Ocean Territory" },
    { value: "BN", text: "Brunei Darussalam" },
    { value: "BG", text: "Bulgaria" },
    { value: "BF", text: "Burkina Faso" },
    { value: "BI", text: "Burundi" },
    { value: "CV", text: "Cabo Verde" },
    { value: "KH", text: "Cambodia" },
    { value: "CM", text: "Cameroon" },
    { value: "KY", text: "Cayman Islands" },
    { value: "CF", text: "Central African Republic" },
    { value: "TD", text: "Chad" },
    { value: "CL", text: "Chile" },
    { value: "CN", text: "China" },
    { value: "CX", text: "Christmas Island" },
    { value: "CC", text: "Cocos (Keeling) Islands" },
    { value: "CO", text: "Colombia" },
    { value: "KM", text: "Comoros" },
    { value: "CG", text: "Congo" },
    { value: "CD", text: "Congo" },
    { value: "CK", text: "Cook Islands" },
    { value: "CR", text: "Costa Rica" },
    { value: "CI", text: "Cote d'Ivoire" },
    { value: "HR", text: "Croatia" },
    { value: "CU", text: "Cuba" },
    { value: "CW", text: "Curacao" },
    { value: "CY", text: "Cyprus" },
    { value: "CZ", text: "Czechia" },
    { value: "DK", text: "Denmark" },
    { value: "DJ", text: "Djibouti" },
    { value: "DM", text: "Dominica" },
    { value: "DO", text: "Dominican Republic" },
    { value: "EC", text: "Ecuador" },
    { value: "EG", text: "Egypt" },
    { value: "SV", text: "El Salvador" },
    { value: "GQ", text: "Equatorial Guinea" },
    { value: "ER", text: "Eritrea" },
    { value: "EE", text: "Estonia" },
    { value: "SZ", text: "Eswatini" },
    { value: "ET", text: "Ethiopia" },
    { value: "FK", text: "Falkland Islands (Malvinas)" },
    { value: "FO", text: "Faroe Islands" },
    { value: "FJ", text: "Fiji" },
    { value: "FI", text: "Finland" },
    { value: "FR", text: "France" },
    { value: "GF", text: "French Guiana" },
    { value: "PF", text: "French Polynesia" },
    { value: "TF", text: "French Southern Territories" },
    { value: "GA", text: "Gabon" },
    { value: "GM", text: "Gambia" },
    { value: "GE", text: "Georgia" },
    { value: "DE", text: "Germany" },
    { value: "GH", text: "Ghana" },
    { value: "GI", text: "Gibraltar" },
    { value: "GR", text: "Greece" },
    { value: "GL", text: "Greenland" },
    { value: "GD", text: "Grenada" },
    { value: "GP", text: "Guadeloupe" },
    { value: "GU", text: "Guam" },
    { value: "GT", text: "Guatemala" },
    { value: "GG", text: "Guernsey" },
    { value: "GN", text: "Guinea" },
    { value: "GW", text: "Guinea-Bissau" },
    { value: "GY", text: "Guyana" },
    { value: "HT", text: "Haiti" },
    { value: "HM", text: "Heard Island and McDonald Islands" },
    { value: "VA", text: "Holy See" },
    { value: "HN", text: "Honduras" },
    { value: "HK", text: "Hong Kong" },
    { value: "HU", text: "Hungary" },
    { value: "IS", text: "Iceland" },
    { value: "IN", text: "India" },
    { value: "ID", text: "Indonesia" },
    { value: "IR", text: "Iran (Islamic Republic of)" },
    { value: "IQ", text: "Iraq" },
    { value: "IE", text: "Ireland" },
    { value: "IM", text: "Isle of Man" },
    { value: "IL", text: "Israel" },
    { value: "IT", text: "Italy" },
    { value: "JM", text: "Jamaica" },
    { value: "JP", text: "Japan" },
    { value: "JE", text: "Jersey" },
    { value: "JO", text: "Jordan" },
    { value: "KZ", text: "Kazakhstan" },
    { value: "KE", text: "Kenya" },
    { value: "KI", text: "Kiribati" },
    { value: "KP", text: "Korea (Democratic People's Republic of)" },
    { value: "KR", text: "Korea" },
    { value: "KW", text: "Kuwait" },
    { value: "KG", text: "Kyrgyzstan" },
    { value: "LA", text: "Lao People's Democratic Republic" },
    { value: "LV", text: "Latvia" },
    { value: "LB", text: "Lebanon" },
    { value: "LS", text: "Lesotho" },
    { value: "LR", text: "Liberia" },
    { value: "LY", text: "Libya" },
    { value: "LI", text: "Liechtenstein" },
    { value: "LT", text: "Lithuania" },
    { value: "LU", text: "Luxembourg" },
    { value: "MO", text: "Macao" },
    { value: "MG", text: "Madagascar" },
    { value: "MW", text: "Malawi" },
    { value: "MY", text: "Malaysia" },
    { value: "MV", text: "Maldives" },
    { value: "ML", text: "Mali" },
    { value: "MT", text: "Malta" },
    { value: "MH", text: "Marshall Islands" },
    { value: "MQ", text: "Martinique" },
    { value: "MR", text: "Mauritania" },
    { value: "MU", text: "Mauritius" },
    { value: "YT", text: "Mayotte" },
    { value: "MX", text: "Mexico" },
    { value: "FM", text: "Micronesia (Federated States of)" },
    { value: "MD", text: "Moldova" },
    { value: "MC", text: "Monaco" },
    { value: "MN", text: "Mongolia" },
    { value: "ME", text: "Montenegro" },
    { value: "MS", text: "Montserrat" },
    { value: "MA", text: "Morocco" },
    { value: "MZ", text: "Mozambique" },
    { value: "MM", text: "Myanmar" },
    { value: "NA", text: "Namibia" },
    { value: "NR", text: "Nauru" },
    { value: "NP", text: "Nepal" },
    { value: "NL", text: "Netherlands" },
    { value: "NC", text: "New Caledonia" },
    { value: "NZ", text: "New Zealand" },
    { value: "NI", text: "Nicaragua" },
    { value: "NE", text: "Niger" },
    { value: "NG", text: "Nigeria" },
    { value: "NU", text: "Niue" },
    { value: "NF", text: "Norfolk Island" },
    { value: "MK", text: "North Macedonia" },
    { value: "MP", text: "Northern Mariana Islands" },
    { value: "NO", text: "Norway" },
    { value: "OM", text: "Oman" },
    { value: "PK", text: "Pakistan" },
    { value: "PW", text: "Palau" },
    { value: "PS", text: "Palestine" },
    { value: "PA", text: "Panama" },
    { value: "PG", text: "Papua New Guinea" },
    { value: "PY", text: "Paraguay" },
    { value: "PE", text: "Peru" },
    { value: "PH", text: "Philippines" },
    { value: "PN", text: "Pitcairn" },
    { value: "PL", text: "Poland" },
    { value: "PT", text: "Portugal" },
    { value: "PR", text: "Puerto Rico" },
    { value: "QA", text: "Qatar" },
    { value: "RE", text: "Reunion" },
    { value: "RO", text: "Romania" },
    { value: "RU", text: "Russian Federation" },
    { value: "RW", text: "Rwanda" },
    { value: "BL", text: "Saint Barthelemy" },
    { value: "SH", text: "Saint Helena" },
    { value: "KN", text: "Saint Kitts and Nevis" },
    { value: "LC", text: "Saint Lucia" },
    { value: "MF", text: "Saint Martin (French part)" },
    { value: "PM", text: "Saint Pierre and Miquelon" },
    { value: "VC", text: "Saint Vincent and the Grenadines" },
    { value: "WS", text: "Samoa" },
    { value: "SM", text: "San Marino" },
    { value: "ST", text: "Sao Tome and Principe" },
    { value: "SA", text: "Saudi Arabia" },
    { value: "SN", text: "Senegal" },
    { value: "RS", text: "Serbia" },
    { value: "SC", text: "Seychelles" },
    { value: "SL", text: "Sierra Leone" },
    { value: "SG", text: "Singapore" },
    { value: "SX", text: "Sint Maarten (Dutch part)" },
    { value: "SK", text: "Slovakia" },
    { value: "SI", text: "Slovenia" },
    { value: "SB", text: "Solomon Islands" },
    { value: "SO", text: "Somalia" },
    { value: "ZA", text: "South Africa" },
    { value: "GS", text: "South Georgia and the South Sandwich Islands" },
    { value: "SS", text: "South Sudan" },
    { value: "ES", text: "Spain" },
    { value: "LK", text: "Sri Lanka" },
    { value: "SD", text: "Sudan" },
    { value: "SR", text: "Suriname" },
    { value: "SJ", text: "Svalbard and Jan Mayen" },
    { value: "SE", text: "Sweden" },
    { value: "CH", text: "Switzerland" },
    { value: "SY", text: "Syrian Arab Republic" },
    { value: "TW", text: "Taiwan" },
    { value: "TJ", text: "Tajikistan" },
    { value: "TZ", text: "Tanzania" },
    { value: "TH", text: "Thailand" },
    { value: "TL", text: "Timor-Leste" },
    { value: "TG", text: "Togo" },
    { value: "TK", text: "Tokelau" },
    { value: "TO", text: "Tonga" },
    { value: "TT", text: "Trinidad and Tobago" },
    { value: "TN", text: "Tunisia" },
    { value: "TR", text: "Turkey" },
    { value: "TM", text: "Turkmenistan" },
    { value: "TC", text: "Turks and Caicos Islands" },
    { value: "TV", text: "Tuvalu" },
    { value: "UG", text: "Uganda" },
    { value: "UA", text: "Ukraine" },
    { value: "AE", text: "United Arab Emirates" },
    {
      value: "GB",
      text: "United Kingdom",
    },
    { value: "UM", text: "United States Minor Outlying Islands" },
    { value: "UY", text: "Uruguay" },
    { value: "UZ", text: "Uzbekistan" },
    { value: "VU", text: "Vanuatu" },
    { value: "VE", text: "Venezuela (Bolivarian Republic of)" },
    { value: "VN", text: "Viet Nam" },
    { value: "VG", text: "Virgin Islands (British)" },
    { value: "VI", text: "Virgin Islands (U.S.)" },
    { value: "WF", text: "Wallis and Futuna" },
    { value: "EH", text: "Western Sahara" },
    { value: "YE", text: "Yemen" },
    { value: "ZM", text: "Zambia" },
    { value: "ZW", text: "Zimbabwe" },
  ],




}

export default new Vuex.Store({
  state
});
